import * as React from 'react';

import { CareerCmsContent } from './career-content';
import { CareerCmsProvider } from './cms-provider/career-cms-provider';
import { GlobalCmsContent } from './global-content';
import { GlobalCmsProvider } from './cms-provider/global-cms-provider';

export const CareerContentProvider = ({ children }: { children: React.ReactNode }) => (
  <GlobalCmsProvider>
    {(cmsContent) => {
      return (
        <GlobalCmsContent.Provider value={cmsContent}>
          <CareerCmsProvider>
            {(careerCmsContent) => {
              return (
                <CareerCmsContent.Provider value={careerCmsContent}>
                  {children}
                </CareerCmsContent.Provider>
              );
            }}
          </CareerCmsProvider>
        </GlobalCmsContent.Provider>
      );
    }}
  </GlobalCmsProvider>
);

export default CareerContentProvider;
